import React from "react";
import ButtonNew from "./ButtonNew";

const ButtonNewExample: React.FC = () => (
	<div className="max-w-2xl space-y-8 p-6">
		<h3 className="text-lg font-semibold">ButtonNew</h3>
		<p className="text-sm text-gray-600">
			Tailwind replacement for the styled-components Button. Fixed height so buttons in a row always
			match, and it renders an <code>&lt;a&gt;</code> when given <code>href</code> instead of
			needing an anchor wrapper.
		</p>

		<div>
			<h4 className="mb-2 font-medium">Variants</h4>
			<div className="flex flex-wrap items-center gap-3">
				<ButtonNew variant="primary">Skapa fakturor</ButtonNew>
				<ButtonNew variant="danger">Ta bort</ButtonNew>
				<ButtonNew variant="dark">Visa fakturajournal</ButtonNew>
				<ButtonNew variant="neutral">Avbryt</ButtonNew>
			</div>
		</div>

		<div>
			<h4 className="mb-2 font-medium">Mixed buttons and links stay aligned</h4>
			<div className="flex items-center gap-3">
				<ButtonNew variant="danger">Ta bort</ButtonNew>
				<ButtonNew variant="dark" href="#" target="_blank" rel="noopener noreferrer">
					Visa fakturajournal
				</ButtonNew>
				<ButtonNew variant="primary">Skapa fakturor</ButtonNew>
			</div>
		</div>

		<div>
			<h4 className="mb-2 font-medium">Disabled</h4>
			<div className="flex items-center gap-3">
				<ButtonNew variant="primary" disabled>
					Skapa fakturor
				</ButtonNew>
				<ButtonNew variant="danger" disabled>
					Ta bort
				</ButtonNew>
			</div>
		</div>

		<div>
			<h4 className="mb-2 font-medium">Full width via className</h4>
			<ButtonNew variant="primary" className="w-full">
				Förhandsgranska
			</ButtonNew>
		</div>
	</div>
);

export default ButtonNewExample;
